import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* eslint-disable @repo/internal/react/no-class-components */

/* There is no good way to replace ErrorBoundary class components with a
 * functional component; currently no functional hook that can replace
 * 'componentDidCatch'.
 * Source: https://react.dev/reference/react/Component#catching-rendering-errors-with-an-error-boundary
 *
 * But I needed to get 'createAnalyticsEvent' via a hook hence
 * the wrapped class component.
 */

import React from 'react';
import { useIntl } from 'react-intl-next';
import { EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { UnhandledErrorScreen } from '@atlassian/generative-ai-modal/screens/UnhandledError';
import { useFireAIAnalyticsEvent } from '../../../analytics/utils';
import { markdownConversionErrorName } from '../../../ui/MarkdownConversionError';
import { ErrorUtils } from '../../../utils/errors';
import errorMessages from './messages';
export var ModalRegionErrorBoundary = function ModalRegionErrorBoundary(props) {
  var fireAIAnalyticsEvent = useFireAIAnalyticsEvent();
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(ExperienceApplicationErrorBoundaryClass, _extends({}, props, {
    fireAIAnalyticsEvent: fireAIAnalyticsEvent,
    formatMessage: formatMessage
  }));
};
var ExperienceApplicationErrorBoundaryClass = /*#__PURE__*/function (_React$Component) {
  _inherits(ExperienceApplicationErrorBoundaryClass, _React$Component);
  var _super = _createSuper(ExperienceApplicationErrorBoundaryClass);
  function ExperienceApplicationErrorBoundaryClass() {
    var _this;
    _classCallCheck(this, ExperienceApplicationErrorBoundaryClass);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getFallbackMessage", function (descriptor) {
      return _this.props.formatMessage(descriptor);
    });
    _defineProperty(_assertThisInitialized(_this), "state", {
      errorCaptured: false,
      fallbackMessage: _this.getFallbackMessage(errorMessages.unhandledErrorMessage)
    });
    return _this;
  }
  _createClass(ExperienceApplicationErrorBoundaryClass, [{
    key: "shouldRecover",
    value: function shouldRecover() {
      return this.state.errorCaptured;
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      if (error.name === markdownConversionErrorName) {
        var errorHasTypeProperty = 'type' in error;
        var errorSubType = errorHasTypeProperty ? error.type : undefined;
        this.props.fireAIAnalyticsEvent({
          payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
              componentStack: errorInfo.componentStack || '',
              errorType: 'markdownToProseMirrorError',
              errorSubType: errorSubType,
              errorMessage: ErrorUtils.extractErrorMessage(error)
            },
            eventType: EVENT_TYPE.OPERATIONAL
          }
        });
        this.setState({
          errorCaptured: true,
          fallbackMessage: this.getFallbackMessage(errorMessages.markdownErrorMessage)
        });
      } else {
        this.props.fireAIAnalyticsEvent({
          payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
              componentStack: errorInfo.componentStack || '',
              errorMessage: ErrorUtils.extractErrorMessage(error)
            },
            eventType: EVENT_TYPE.OPERATIONAL
          }
        });
        this.setState({
          errorCaptured: true,
          fallbackMessage: this.getFallbackMessage(errorMessages.unhandledErrorMessage)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this.shouldRecover()) {
        return /*#__PURE__*/React.createElement(UnhandledErrorScreen, {
          text: this.state.fallbackMessage,
          onCancel: this.props.onCloseFallback
        });
      }
      return this.props.children;
    }
  }]);
  return ExperienceApplicationErrorBoundaryClass;
}(React.Component);